import AxiosFunctions from './axiosFunctions'

/** APIs Biomax: mismo contrato que apiList pero contra /api/biomax (rutas biomaxRoutes en el back). */
const uri = {
    getRolesUri: '/biomax/roles',
    getPermisosUri: '/biomax/permisos',
    savePermisosUri: '/biomax/permisos/asignar-desasignar'
}

export default {
    getRoles: async (params = {}) => {
        const query = new URLSearchParams(params).toString();
        return await AxiosFunctions.get(uri.getRolesUri + (query ? "?" + query : ""));
    },

    saveRoles: async (data) => {
        return await AxiosFunctions.post(uri.getRolesUri, data);
    },

    editRoles: async (data) => {
        let id = data[0];
        let params = { name: data[1], guard_name: data[2] };
        if (data[3] != null) params.cliente_plataforma_id = data[3];
        return await AxiosFunctions.patch(uri.getRolesUri + '/' + id, params);
    },

    deleteRoles: async (id) => {
        return await AxiosFunctions.delete(uri.getRolesUri + '/' + id, {});
    },

    getPermisos: async (id) => {
        return await AxiosFunctions.get(uri.getPermisosUri + "/" + id);
    },

    savePermisos: async (data) => {
        return await AxiosFunctions.post(uri.savePermisosUri, data);
    },
}
